import axios from "../plugins/parseAxios";

export class ProductCategoryAPI {
  constructor(props) {}
  static createProductCategory(payload) {
    return axios.post("functions/createProductCategory", payload);
  }
  static getProductCategoies(payload) {
    return axios.post("functions/getProductCategories", payload);
  }
  static updateProductCategory(payload) {
    return axios.post("functions/updateProductCategory", payload);
  }
}
